const NAME_FIELD_IDS = ['first_name', 'last_name'];

/**
 * Uppercases only the first character, preserving the rest of the value
 * (accented Latin letters via toLocaleUpperCase; a no-op on scripts with no
 * case distinction, e.g. CJK or Arabic). locale is explicit rather than the
 * runtime default so casing follows the page's chosen language, not the
 * visitor's browser/OS locale (e.g. Turkish's dotted/dotless i pair).
 */
export const capitalizeFirst = (value, locale) => {
  if (!value) return value;

  return value.charAt(0).toLocaleUpperCase(locale) + value.slice(1);
};

/**
 * Auto-capitalizes the register form's first/last name fields on blur, so
 * signups land with a capitalized name without hard-rejecting any input.
 */
export const initNameCapitalization = () => {
  const locale = document.documentElement.lang || undefined;

  for (const id of NAME_FIELD_IDS) {
    const field = document.getElementById(id);

    field?.addEventListener('blur', () => {
      field.value = capitalizeFirst(field.value, locale);
    });
  }
};
